import type { RecordResponseRequest, RecordResponseResult } from '@assessments/shared'
import { apiFetch } from '../../services/apiClient.js'
import { ApiError, assertOk } from '../../services/apiError.js'

/** The chosen industry was retired between loading the section and saving (a 422 with this code). */
export function isIndustryUnavailable(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === 422 &&
    (err.body as { code?: unknown } | undefined)?.code === 'industry_unavailable'
  )
}

/**
 * Persists one question's answer to the server via the response recording endpoint.
 * Called for each edited answer when the respondent marks the section complete
 * (EA-62) — not per keystroke. A non-2xx is a persistence failure, never a
 * validation signal; the required-answered check is the Mark Complete gate's concern.
 */
export async function recordResponse(
  organizationSurveyId: string,
  questionId: string,
  body: RecordResponseRequest,
): Promise<RecordResponseResult> {
  const res = await apiFetch(
    `/assessments/${encodeURIComponent(organizationSurveyId)}/questions/${encodeURIComponent(questionId)}/response`,
    { method: 'PUT', body: JSON.stringify(body) },
  )
  await assertOk(res, 'save answer')
  return (await res.json()) as RecordResponseResult
}
